import { $, $$ } from '@utils';
import { Calendar } from 'vanilla-calendar-pro';
import i18next from 'i18next';

function init() {
  if (!$('[data-au-calendar]')) return;

  addEventListeners();
  calendarDatalayer();
  applyColors();
}

function addEventListeners() {
  const dateDivs = $$('[data-au-calendar-date]');
  const highlightedClass = 'au-datepicker__date-btn--highlighted';
  const noEventsContainer = $('[data-au-calendar-no-events]');
  const showMoreContainer = $('[data-au-calendar-cards-more]');
  const seeMoreBtn = $$('[data-au-calendar-more]');
  const textContent = $$('[data-au-calendar-card-text]');
  const currentDate = new Date();

  // Array with all events
  const dates = [];

  dateDivs.forEach((div) => {
    const dateStr = div.getAttribute('data-au-calendar-date');
    const date = new Date(dateStr);
    dates.push(date);
  });

  //Function to get future dates in chronological order from the current date
  function getNextFutureDates(num = 3, excludeDates = []) {
    // Filter future dates (in the future or from the same month)
    const futureDates = dates.filter((date) => {
      return (
        date >= currentDate && !excludeDates.some((excludeDate) => excludeDate.toISOString() === date.toISOString())
      );
    });

    // Sort future dates chronologically
    return futureDates.sort((a, b) => a - b).slice(0, num);
  }

  // Function to update the calendar
  function updateCalendar() {
    const month = currentDate.getMonth();
    const year = currentDate.getFullYear();

    // Filter dates of the current month and year
    const filteredDates = dates.filter((date) => {
      return date.getMonth() === month && date.getFullYear() === year;
    });

    dateDivs.forEach((div) => div.classList.add('au-hide'));

    // If the month has its own events, display up to 3 dates of the month
    let monthDates = [];
    if (filteredDates.length > 0) {
      monthDates = filteredDates.slice(0, 3);
    }

    // If the month has fewer than 3 dates, fill them with future dates
    if (monthDates.length < 3) {
      const remainingDates = getNextFutureDates(3 - monthDates.length, monthDates);
      monthDates = monthDates.concat(remainingDates);
    }

    // Show the dates of the month
    monthDates.forEach((date) => {
      const div = document.querySelector(
        `[data-au-calendar-card][data-au-calendar-date="${date.toISOString().split('T')[0]}"]`,
      );
      if (div) {
        div.classList.remove('au-hide');
      }
    });

    // If the month has more than 3 dates, show the "See more" button
    if (filteredDates.length > 3) {
      showMoreContainer.classList.remove('au-hide');
      $('[data-au-calendar-cards-more-link]').addEventListener('click', (e) => {
        e.preventDefault();
        filteredDates.slice(3).forEach((date) => {
          const div = document.querySelector(
            `[data-au-calendar-card][data-au-calendar-date="${date.toISOString().split('T')[0]}"]`,
          );
          if (div) {
            div.classList.remove('au-hide');
            applyColors();
          }
        });
        showMoreContainer.classList.add('au-hide');
      });
    } else {
      showMoreContainer.classList.add('au-hide');
    }
    // If there are no dates in this month, display a message
    if (monthDates.length === 0) {
      noEventsContainer.classList.remove('au-hide');
      noEventsContainer.innerHTML = '<p class="au-calendar__no-cards-text t-label">No hay eventos a la vista.</p>';
      const image = document.createElement('img');
      image.className = 'au-calendar__no-cards-img';
      image.src = 'images/modules/Calendar/no-events.webp';
      noEventsContainer.appendChild(image);
    } else if (filteredDates.length === 0) {
      monthDates = getNextFutureDates(3, []);
      noEventsContainer.classList.remove('au-hide');
      noEventsContainer.innerHTML =
        '<p class="t-label">No hay eventos en la fecha seleccionada. Los eventos mostrados pertenecen a los meses posteriores.</p>';
    } else {
      noEventsContainer.classList.add('au-hide');
      //noEventsContainer.innerHTML = '';
    }
    applyColors();
  }

  const options = {
    selectedHolidays: dates,
    locale: i18next.language,
    styles: {
      calendar: 'au-datepicker',
      controls: 'au-datepicker__controls',
      grid: 'au-datepicker__grid',
      column: 'au-datepicker__column',
      header: 'au-datepicker__header',
      headerContent: 'au-datepicker__header-content',
      month: 'au-datepicker__month-selector',
      year: 'au-datepicker__year-selector',
      arrowPrev: 'au-datepicker__arrow au-datepicker__arrow--prev',
      arrowNext: 'au-datepicker__arrow au-datepicker__arrow--next',
      wrapper: 'au-datepicker__wrapper',
      content: 'au-datepicker__content',
      months: 'au-datepicker__months',
      monthsMonth: 'au-datepicker__month',
      years: 'au-datepicker__years',
      yearsYear: 'au-datepicker__year',
      week: 'au-datepicker__week',
      weekDay: 'au-datepicker__week-day',
      weekNumbers: 'au-datepicker__week-numbers',
      weekNumbersTitle: 'au-datepicker__week-numbers-title',
      weekNumbersContent: 'au-datepicker__week-numbers-content',
      weekNumber: 'au-datepicker__week-number',
      dates: 'au-datepicker__dates',
      date: 'au-datepicker__date',
      dateBtn: 'au-datepicker__date-btn',
      datePopup: 'au-datepicker__date-popup',
      dateRangeTooltip: 'au-datepicker__date-range-tooltip',
      time: 'au-datepicker__time',
      timeContent: 'au-datepicker__time-content',
      timeHour: 'au-datepicker__time-hour',
      timeMinute: 'au-datepicker__time-minute',
      timeKeeping: 'au-datepicker__time-keeping',
      timeRanges: 'au-datepicker__time-ranges',
      timeRange: 'au-datepicker__time-range',
    },
    onCreateDateEls(self) {
      const calendar = self.context.mainElement;
      const selectedEvent = calendar.querySelectorAll('[data-vc-date-holiday]');

      selectedEvent.forEach(function (date) {
        date.querySelector('.au-datepicker__date-btn').classList.add(highlightedClass);
      });
    },
    onClickArrow(self, e) {
      const direction = e.target.dataset.vcArrow === 'next' ? 'siguiente' : 'previa';

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickSlider',
        item_id: `fecha_${direction}`,
      });

      currentDate.setMonth(self.context.selectedMonth);
      currentDate.setYear(self.context.selectedYear);
      updateCalendar();
      resetViewMore();
    },
    onClickDate(self) {
      setTimeout(() => {
        currentDate.setMonth(self.context.selectedMonth);
        currentDate.setYear(self.context.selectedYear);
        updateCalendar();
        resetViewMore();
      }, 0);
    },
    onClickMonth(self) {
      currentDate.setMonth(self.context.selectedMonth);
      currentDate.setYear(self.context.selectedYear);
      updateCalendar();
    },
    onClickYear(self) {
      currentDate.setMonth(self.context.selectedMonth);
      currentDate.setYear(self.context.selectedYear);
      updateCalendar();
    },
    onUpdate(self) {
      currentDate.setMonth(self.context.selectedMonth);
      currentDate.setYear(self.context.selectedYear);
      updateCalendar();
    },
  };

  // initialization
  const calendar = new Calendar('[data-au-calendar-events]', options);
  calendar.init();

  // Function to select the date in the calendar when clicking "See more"
  function goToDateViewMore() {
    seeMoreBtn.forEach((btn) => {
      btn.addEventListener('click', () => {
        const date = new Date(btn.closest('[data-au-calendar-card]').getAttribute('data-au-calendar-date'));
        const month = date.getMonth();
        if (btn.textContent === 'Leer más') {
          calendar.set({
            enableJumpToSelectedDate: true,
            selectedDates: [],
            selectedMonth: month,
          });
        } else {
          calendar.set({
            enableJumpToSelectedDate: true,
            selectedDates: [date],
          });
          calendar.update();
        }
      });
    });
  }
  // Function to hide the "See more" button for events when changing the month
  function resetViewMore() {
    textContent.forEach((text) => {
      if (text.classList.contains('show-more')) {
        text.classList.remove('show-more');
      }
    });

    seeMoreBtn.forEach((btn) => {
      if (btn.textContent === 'Leer menos') {
        btn.textContent = 'Leer más';
      }
    });
  }

  updateCalendar();
  goToDateViewMore();
}

// Function to send datalayer when click on month and year selectors
function calendarDatalayer() {
  document.addEventListener('click', (e) => {
    if (e.target.dataset.vc === 'month') {
      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickSelector',
        item_id: 'selector_month',
      });
    }

    if (e.target.dataset.vc === 'year') {
      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickSelector',
        item_id: 'selector_year',
      });
    }
  });
}

// Function to assign colors cyclically to the events
function applyColors() {
  const colors = ['#f3bdff', '#90ffbb', '#e0ff48'];
  const events = $$('[data-au-calendar-card]:not(.au-hide)');
  events.forEach((div, index) => {
    const colorIndex = index % colors.length;
    div.querySelector('.au-calendar-card__date').style.backgroundColor = colors[colorIndex];
  });
}

export default { init };
